import { Content } from 'components/Layout';
import React from 'react';
import Header from 'components/commons/header';
import Footer from 'components/commons/footer';
import Announcement from "pages/Announcement";

class AnnouncementLayout extends React.Component {
  render() {
    return (
      <main>
        <Content fluid>
          <Header />
          <Announcement />
          <Footer />
        </Content>
      </main>
    );
  }
}

export default AnnouncementLayout;
